<template>
    <v-app class="primary" id="recover">
        <v-content>
            <v-container fill-height fluid>
                <v-layout align-center justify-center>
                    <v-flex lg4 md4 sm8 xs12>
                        <v-card class="elevation-1 pa-3">
                            <v-form @submit.prevent="recover" v-if="token_uid.length === 0">
                                <v-card-text>
                                    <div class="layout column align-center">
                                       <router-link to="/login">
                                           <img alt="چاپچی" height="120" src="/static_reseller/m.png" width="120">
                                       </router-link>
                                        <h1 class="flex my-4 primary--text">بازیابی رمزعبور</h1>
                                    </div>
                                    <v-text-field append-icon="person" label="موبایل" name="mobile" type="text"
                                                  data-ltr
                                                  v-model="model.mobile"></v-text-field>
                                    <v-text-field append-icon="email"
                                                  data-ltr
                                                  id="email" label="ایمیل" name="email"
                                                  type="email" v-model="model.email"></v-text-field>

                                </v-card-text>
                                <v-card-actions>
                                    <v-btn :loading="loading" block color="primary" type="submit">بررسی</v-btn>
                                </v-card-actions>
                            </v-form>
                            <v-form v-else @ v-on:submit.prevent="verify" ref="tform">
                                <v-card-text>
                                    <div class="layout column align-center">
                                        <router-link to="/">
                                            <img alt="چاپچی" height="120" src="/static_reseller/m.png" width="120">
                                        </router-link>
                                        <h1 class="flex my-4 primary--text">تغییر رمز</h1>
                                    </div>
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field
                                                    label="رمزعبور"
                                                    name="password"
                                                    type="password"
                                                    data-number
                                                    required
                                                    :rules="[rules.required]"
                                                    v-model="password"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex>
                                            <v-text-field
                                                    label="تکرار رمزعبور"
                                                    name="repassword"
                                                    type="password"
                                                    data-number
                                                    required
                                                    :rules="[rules.required]"
                                                    v-model="password2"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field
                                                    label="کد تایید"
                                                    name="name"
                                                    type="text"
                                                    maxlength="7"
                                                    data-number
                                                    required
                                                    :rules="[rules.required]"
                                                    v-model="token_user"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-chip :style="resend?'cursor:pointer;':''" @click="recover"
                                                :color="resend?'green':'gray'" :text-color="resend?'white':'blue'">ارسال
                                            مجدد {{timer_counter}}
                                        </v-chip>
                                    </v-layout>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn :loading="loading" block color="primary" type="submit">
                                        تایید
                                    </v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    model: {
      mobile: '',
      email: ''
    },
    password: '',
    password2: '',
    token_uid: '',
    token_user: '',
    interval: null,
    timer: 0,
    resend: false,
    timer_counter: '(02:00)',
    rules: {
      required: (value) => !!value || 'پر کردن این فیلد اجباری است.',
    }
  }),
  methods: {
    async recover () {
      this.loading = true;
      try {
        const res = await this.axios.post('/reseller/recover_password', this.model);
        this.token_uid = res.data.content;
        this.timer = 120;
        this.interval = setInterval(this.countDown, 1000);
      } catch (error) {
        if (typeof error.response.data.message === 'undefined') {
          window.getApp.$emit('SHOW_ERROR', 'خطا در ارتباط!');
          return;
        }
        window.getApp.$emit('SHOW_ERROR', error.response.data.message);
      } finally {
        this.loading = false;
      }
    },
    countDown () {
      let n = this.timer;
      if (n > 0) {
        n = n - 1;
        this.timer = n;
        let minute = Math.floor(n / 60);
        let second = n % 60;
        second = second < 10 ? '0' + second : second;
        this.timer_counter = '(' + minute + ':' + second + ')';
      } else {
        clearInterval(this.interval);
        this.timer_counter = '';
        this.resend = true;
      }
    },
    async verify () {
      if (this.password !== this.password2) {
        window.getApp.$emit('SHOW_ERROR', 'رمزعبور و تکرار آن تطابق ندارند');
        return;
      }

      if (this.password.length < 8) {
        window.getApp.$emit('SHOW_ERROR', 'رمزعبور حداقل میبایست');
        return;
      }

      this.loading = true;
      try {
        await this.axios.post('/reseller/recover_password/verify', {
          password: this.password,
          uid: this.token_uid,
          user_token: this.token_user
        });
        window.getApp.$emit('SHOW_SUCCESS', 'با موفقیت انجام شد');
        this.$router.push('/');
      } catch (error) {
        if (typeof error.response.data.message === 'undefined') {
          window.getApp.$emit('SHOW_ERROR', 'خطا در ارتباط!');
          return;
        }
        window.getApp.$emit('SHOW_ERROR', error.response.data.message);
      } finally {
        this.loading = false;
      }

    }
  }
};
</script>
<style scoped lang="css">
    #recover {
        height: 50%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        z-index: 0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/RecoverPassword.vue